import React from 'react';
import SURVEY_CHART_TYPE from '../constants/SurveyChartTypes';

/**
 * @typedef {object} SurveyLabelColumnRecord
 * @property {string} Color
 * @property {number} ChartType
 * @property {string} Label
 */

/**
 * @typedef {object} SurveyLabelColumnProps
 * @property {SurveyLabelColumnRecord} record
 */

/**
 * @param {SurveyLabelColumnProps} props
 */
const SurveyLabelColumn = props => {
  const { record } = props;
  const isLine = record.ChartType === SURVEY_CHART_TYPE.LINE;
  return (
    <div className='survey-results__label-cell'>
      <div
        className={`survey-results__color-box ${isLine ? 'line' : 'bar'}`}
        style={{ backgroundColor: record.Color }}
      />
      <span>{record.Label}</span>
    </div>
  );
};

export default SurveyLabelColumn;
